import React from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { FaStar, FaQuoteRight } from "react-icons/fa";
import ClientsImg from "../../assest/Clients.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Translation dictionaries
const translations = {
  gb: {
    heading: "What Happy Clients Say About Us?",
    testimonials: [
      {
        name: "Ahmed Al-Mutairi",
        image: ClientsImg,
        position: "Operations Manager, Etihad Gharbia",
        rating: 5,
        review: `Etihad Gharbia Contracting Company consistently delivers professional, dependable, and timely services. Their strong client relationships and commitment to excellence are evident across contracting, manpower, equipment rental, and transport projects.`,
      },
      {
        image: ClientsImg,
        name: "Sara Al-Fahad",
        position: "Project Lead, Gulf Construction",
        rating: 5,
        review: `Working with Etihad Gharbia has been an excellent experience. Their team is responsive, highly skilled, and always meets deadlines. They truly understand our project requirements and deliver exceptional results.`,
      },
      {
        image: ClientsImg,
        name: "Mohammed Saleh",
        position: "Site Engineer, Al Naseem Builders",
        rating: 4,
        review: `Their professionalism and dedication are impressive. We have relied on their equipment rental services multiple times and have been very satisfied with the quality and support provided.`,
      },
    ],
  },
  sa: {
    heading: "ماذا يقول العملاء السعداء عنا؟",
    testimonials: [
      {
        name: "أحمد المطيري",
        position: "مدير العمليات، اتحاد غربية",
        rating: 5,
        review: `تقدم شركة اتحاد غربية للمقاولات خدمات احترافية وموثوقة وفي الوقت المناسب باستمرار. تتجلى علاقاتهم القوية مع العملاء والتزامهم بالتميز في مشاريع المقاولات، القوى العاملة، تأجير المعدات، وخدمات النقل.`,
      },
      {
        name: "سارة الفهد",
        position: "قائدة المشروع، شركة الخليج للبناء",
        rating: 5,
        review: `كانت العمل مع اتحاد غربية تجربة ممتازة. فريقهم سريع الاستجابة، ذو مهارات عالية، ويحترم المواعيد دائمًا. إنهم يفهمون متطلبات مشروعنا ويقدمون نتائج استثنائية.`,
      },
      {
        name: "محمد صالح",
        position: "مهندس الموقع، شركة النسيج للبناء",
        rating: 4,
        review: `إن احترافيتهم وتفانيهم مثير للإعجاب. لقد اعتمدنا على خدمات تأجير المعدات الخاصة بهم عدة مرات وكنا راضين جدًا عن الجودة والدعم المقدم.`,
      },
    ],
  },
  fr: {
    heading: "Que disent nos clients satisfaits à notre sujet ?",
    testimonials: [
      {
        name: "Ahmed Al-Mutairi",
        position: "Responsable des opérations, Etihad Gharbia",
        rating: 5,
        review: `Etihad Gharbia Contracting Company fournit constamment des services professionnels, fiables et ponctuels. Leurs relations solides avec les clients et leur engagement envers l'excellence sont évidents dans les projets de construction, de main-d'œuvre, de location d'équipements et de transport.`,
      },
      {
        name: "Sara Al-Fahad",
        position: "Chef de projet, Gulf Construction",
        rating: 5,
        review: `Travailler avec Etihad Gharbia a été une excellente expérience. Leur équipe est réactive, hautement qualifiée et respecte toujours les délais. Ils comprennent vraiment nos besoins de projet et livrent des résultats exceptionnels.`,
      },
      {
        name: "Mohammed Saleh",
        position: "Ingénieur de chantier, Al Naseem Builders",
        rating: 4,
        review: `Leur professionnalisme et leur dévouement sont impressionnants. Nous avons fait appel à leurs services de location d'équipements à plusieurs reprises et nous sommes très satisfaits de la qualité et du soutien fourni.`,
      },
    ],
  },
  de: {
    heading: "Was sagen zufriedene Kunden über uns?",
    testimonials: [
      {
        name: "Ahmed Al-Mutairi",
        position: "Betriebsleiter, Etihad Gharbia",
        rating: 5,
        review: `Die Etihad Gharbia Contracting Company liefert durchweg professionelle, zuverlässige und pünktliche Dienstleistungen. Ihre starken Kundenbeziehungen und ihr Engagement für Exzellenz zeigen sich in Projekten im Bereich Auftragsvergabe, Arbeitskräfte, Geräteverleih und Transport.`,
      },
      {
        name: "Sara Al-Fahad",
        position: "Projektleiterin, Gulf Construction",
        rating: 5,
        review: `Die Zusammenarbeit mit Etihad Gharbia war eine hervorragende Erfahrung. Ihr Team ist reaktionsschnell, hochqualifiziert und hält stets Termine ein. Sie verstehen unsere Projektanforderungen wirklich und liefern außergewöhnliche Ergebnisse.`,
      },
      {
        name: "Mohammed Saleh",
        position: "Baustellen-Ingenieur, Al Naseem Builders",
        rating: 4,
        review: `Ihr Professionalismus und ihre Hingabe sind beeindruckend. Wir haben mehrfach auf ihre Geräteverleih-Dienste zurückgegriffen und waren mit der Qualität und Unterstützung sehr zufrieden.`,
      },
    ],
  },
};

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="position-relative d-flex justify-content-center align-items-center px-2 px-md-5">
      {/* Overlapping Profile Image */}
      <img
        src={testimonial.image}
        alt={testimonial.name}
        className="rounded-circle shadow"
        style={{
          width: "120px",
          height: "120px",
          objectFit: "cover",
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
          border: "4px solid white",
          backgroundColor: "white",
        }}
      />

      {/* Testimonial Content Card */}
      <div
        className="bg-white p-4 ps-5 ps-md-5 pe-3 rounded-4 shadow-sm w-100"
        style={{ borderRadius: "20px", paddingLeft: "80px", marginLeft: "40px" }}
      >
        {/* Quote icon top-right */}
        <div
          className="position-absolute top-2 end-0 translate-middle d-none d-md-flex"
          style={{
            transform: "translate(50%, -50%)",
            backgroundColor: "#c8102e",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaQuoteRight className="text-white" />
        </div>

        {/* Rating */}
        <div className="mb-2">
          {[...Array(testimonial.rating)].map((_, i) => (
            <FaStar key={i} color="#ffc107" className="me-1" />
          ))}
        </div>

        {/* Review */}
        <p className="text-dark" style={{ lineHeight: "1.6", fontSize: "0.95rem" }}>
          {testimonial.review}
        </p>

        {/* Name and Position */}
        <div className="d-flex align-items-center mt-4">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="rounded-circle me-3 d-md-none"
            style={{ width: "45px", height: "45px", objectFit: "cover" }}
          />
          <div>
            <strong>{testimonial.name}</strong>
            <br />
            <small className="text-muted">{testimonial.position}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

const Testimonial = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <section className="py-5 bg-white" dir={language === 'sa' ? 'rtl' : 'ltr'}>
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            {t.heading.split(' ').slice(0, -2).join(' ')} <br />
            <span className="text-dark">{t.heading.split(' ').slice(-2).join(' ')}</span>
          </h2>
          <div className="d-flex justify-content-center align-items-center mt-2">
            <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e" }} />
            <div style={{ width: "8px", height: "3px", backgroundColor: "#c8102e", margin: "0 5px" }} />
            <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e" }} />
          </div>
        </div>

        {/* Carousel */}
        <Slider {...settings}>
          {t.testimonials.map((testimonial) => (
            <div key={testimonial.name}>
              <TestimonialCard testimonial={testimonial} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;